module.exports = __webpack_public_path__ + "assets/icon-journey-proposal.cf340177.svg";